import { Navigate, useRoutes } from 'react-router-dom';

import { DashboardLayout } from '../layouts/dashboard';
import { SimpleLayout } from '../layouts/simple/SimpleLayout';
import ForgotPassword from '../pages/Auth/ForgotPassword';
import ForgotPasswordEmailSent from '../pages/Auth/ForgotPasswordEmailSent';
import SignIn from '../pages/Auth/SignIn';
import SignUp from '../pages/Auth/SignUp';
import SignUpCompletePage from '../pages/Auth/SignUpCompletePage';
import SignUpPasswordChang from '../pages/Auth/SignUpPasswordChang';
import SignUpVerification from '../pages/Auth/SignUpVerification';
import Orders from '../pages/Clearer';
import Crm from '../pages/Crm/Crm';
import HighValue from '../pages/Home/HighValue';
import Home from '../pages/Home/Home';
import PackageWithin from '../pages/Home/PackageWithin';
import Withheld from '../pages/Home/Withheld';
import Notifications from '../pages/Notifications';
import Page404 from '../pages/Page404';
import PickList from '../pages/PickList';
import Settings from '../pages/Settings';
import AdminUser from '../pages/Users/AdminUser';
import ClearerUser from '../pages/Users/ClearerUser';
import DispatcherUser from '../pages/Users/DispatcherUser';
import Users from '../pages/Users/Users';
import WarehouserUser from '../pages/Users/WarehouserUser';
import Warehouse from '../pages/Warehouse/Warehouse';
import WarehouseArea from '../pages/Warehouse/WarehouseArea';
import {
  ACCOUNT,
  ADMINUSER,
  CLEARER,
  CLEARERUSER,
  CRM,
  DISPATCHERUSER,
  HIGH_VALUE,
  HOME,
  NOTFOUND,
  NOTIFICATION,
  PACKAGE_WITHIN,
  PICKLIST,
  RESET_PASSWORD,
  RESET_PASSWORD_VERIFY,
  SETTINGS,
  SIGNIN,
  SIGNUP,
  SIGNUPCHANGEPASSWORD,
  SIGNUPCOMPLETE,
  USER,
  VERIFY_OTP,
  WAREHOUSE,
  WAREHOUSEAREA,
  WAREHOUSEUSER,
  WITHHELD,
} from './routeConstants';

export default function Router() {
  return useRoutes([
    {
      path: HOME,
      element: <DashboardLayout />,
      children: [
        {
          path: HOME,
          element: <Home />,
        },
        {
          path: `${PACKAGE_WITHIN}/:airbillNumber/:airbillId`,
          element: <PackageWithin />,
        },
        {
          path: `${HIGH_VALUE}/:airbillNumber/:airbillId`,
          element: <HighValue />,
        },
        {
          path: `${WITHHELD}/:airbillNumber/:airbillId`,
          element: <Withheld />,
        },
        {
          path: CLEARER,
          element: <Orders />,
        },
        {
          path: PICKLIST,
          element: <PickList />,
        },
        {
          path: WAREHOUSE,
          element: <Warehouse />,
        },
        {
          path: CRM,
          element: <Crm />,
        },

        {
          path: `${WAREHOUSE}/:warehouseId/:warehouseName/:state/:stateId/${WAREHOUSEAREA}`,
          element: <WarehouseArea />,
        },
        {
          path: USER,
          element: <Users />,
          children: [
            { path: '', element: <AdminUser /> },
            { path: ADMINUSER, element: <AdminUser /> },
            { path: CLEARERUSER, element: <ClearerUser /> },
            { path: DISPATCHERUSER, element: <DispatcherUser /> },
            { path: WAREHOUSEUSER, element: <WarehouserUser /> },
          ],
        },
        {
          path: NOTIFICATION,
          element: <Notifications />,
        },

        {
          path: SETTINGS,
          element: <Settings />,
        },
      ],
    },

    {
      path: ACCOUNT,
      element: <SimpleLayout />,
      children: [
        { path: SIGNIN, element: <SignIn /> },
        { path: `${SIGNUP}/:base64Secret`, element: <SignUp /> },
        { path: SIGNUPCHANGEPASSWORD, element: <SignUpPasswordChang /> },
        { path: SIGNUPCOMPLETE, element: <SignUpCompletePage /> },
        { path: VERIFY_OTP, element: <SignUpVerification /> },
        { path: RESET_PASSWORD, element: <ForgotPassword /> },
        {
          path: RESET_PASSWORD_VERIFY,
          element: <ForgotPasswordEmailSent />,
        },
        { path: NOTFOUND, element: <Page404 /> },
        { path: '*', element: <Navigate to={`/${NOTFOUND}`} replace /> },
      ],
    },
    { path: '*', element: <Page404 /> },
  ]);
}
